import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, Grid, Scrollbar } from "swiper/modules";

var is_mobile = false;

window.addEventListener("DOMContentLoaded", (event) => {
    checkHeader();
    toggleMobileStyles();
    initiateWidgets();

    const mainMenu = jQuery("nav.elementor-nav-menu--dropdown:not(.elementor-nav-menu--main) .elementor-nav-menu");
    mainMenu.on("beforeshow.smapi", function (e, item) {
        const siblings = jQuery(item).parent().siblings();
        siblings.each(function () {
            const toClose = jQuery(this).find("a.highlighted .sub-arrow");
            toClose.each(function () {
                this.click();
            });
        });
    });
});

const initiateWidgets = function () {
    setupReviewContents();
    const reviewSwipers = document.querySelectorAll(".ti-widget .swiper");
    reviewSwipers.forEach((swip) => {
        const elementorParent = swip.closest(".elementor-element[data-id]");
        const uniqID = elementorParent.getAttribute("data-id");
        const selector = `.elementor-element[data-id='${uniqID}'] .ti-widget`;
        const swiperReview = new Swiper(`${selector} .swiper`, {
            // Configurer Swiper pour utiliser les modules
            modules: [Autoplay, Scrollbar],
            slidesPerView: 1.3,
            spaceBetween: 20,
            speed: 1500,
            // autoplay: {
            //     delay: 3000,
            // },
            scrollbar: {
                el: `${selector} .swiper-scrollbar`,
                hide: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                    slidesOffsetAfter: 110,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 40,
                    slidesOffsetAfter: 110,
                },
                1600: {
                    slidesPerView: 3.5,
                    spaceBetween: 40,
                    slidesOffsetAfter: 110,
                },
            },
        });

        setupReviews();
    });

    const partnerSwipers = document.querySelectorAll(".partner .swiper");
    partnerSwipers.forEach((swip) => {
        const elementorParent = swip.closest(".elementor-element[data-id]");
        const uniqID = elementorParent.getAttribute("data-id");
        const selector = `.elementor-element[data-id='${uniqID}'] .partner`;
        const direction = swip.getAttribute("data-direction");
        const swiperPartner = new Swiper(`${selector} .swiper`, {
            // Configurer Swiper pour utiliser les modules
            modules: [Autoplay],
            slidesPerView: 4,
            loop: true,
            freeMode: true,
            freeModeMomentum: false,
            spaceBetween: 0,
            allowTouchMove: false,
            speed: 2000,
            autoplay: {
                delay: 1,
                reverseDirection: direction,
            },
            breakpoints: {
                768: {
                    slidesPerView: 6,
                },
                1024: {
                    slidesPerView: 9,
                },
            },
        });
    });

    const articlesSwipers = document.querySelectorAll(".last-news .swiper");
    articlesSwipers.forEach((swip) => {
        const elementorParent = swip.closest(".elementor-element[data-id]");
        const uniqID = elementorParent.getAttribute("data-id");
        const selector = `.elementor-element[data-id='${uniqID}'] .last-news`;
        const swiperArticles = new Swiper(`${selector} .swiper`, {
            // Configurer Swiper pour utiliser les modules
            modules: [Navigation, Pagination, Scrollbar, Grid],
            slidesPerView: 1.5,
            spaceBetween: 20,
            slidesOffsetAfter: 40,
            scrollbar: {
                el: `${selector} .swiper-scrollbar`,
                hide: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                    slidesOffsetAfter: 0,
                    scrollbar: {
                        hide: true,
                    },
                },
            },
        });
    });

    const readmores = document.querySelectorAll(".lire-plus");
    readmores.forEach((readmore) => {
        const textMore = readmore.getAttribute("lire-plus") || "Lire la suite";
        const textLess = readmore.getAttribute("lire-moins") || "Cacher";
        const tmp = document.createElement("div");
        const pt = window.getComputedStyle(readmore, null).getPropertyValue("padding-bottom");
        const mt = window.getComputedStyle(readmore, null).getPropertyValue("margin-bottom");

        tmp.style.setProperty("--pt", pt);
        tmp.style.setProperty("--mt", mt);
        tmp.classList.add("read-more");
        tmp.innerHTML = textMore;
        readmore.after(tmp);
        tmp.addEventListener("click", function () {
            if (readmore.classList.contains("lire-plus-open")) {
                readmore.classList.remove("lire-plus-open");
                tmp.innerHTML = textMore;
            } else {
                readmore.classList.add("lire-plus-open");
                tmp.innerHTML = textLess;
            }
        });
    });

    // FAQ
    jQuery(document).on("mousedown touchstart", ".elementor-widget-toggle .elementor-tab-title", function () {
        const self = jQuery(this);
        const toClose = jQuery(this).closest(".elementor-toggle").find(".elementor-tab-title.elementor-active");
        toClose.each(function () {
            const link = jQuery(this);
            if (!link.is(self)) {
                setTimeout(function () {
                    link.trigger("click");
                }, 100);
            }
        });
    });
};

const setupReviewContents = function () {
    const innerStars = document.querySelectorAll(".ti-inner .ti-stars");
    if (innerStars && innerStars.length) {
        innerStars.forEach((stars) => {
            const fullStars = stars.querySelectorAll(".ti-star.f").length;
            // const emptyStars = stars.querySelectorAll(".ti-star.e").length;
            const note = `${fullStars}/5`;
            const tmp = document.createElement("span");
            tmp.innerHTML = note;
            stars.append(tmp);
        });
    }

    const [evalGoogle, globalNote, reviewsNumber] = document.querySelectorAll(".ti-rating-text .nowrap");
    if (evalGoogle && globalNote) {
        evalGoogle.remove();
        const finalNote = parseFloat(
            globalNote.innerHTML.replace("/5", "").replace("<strong>", "").replace("</strong>", "")
        );
        if (finalNote) {
            const nbF = Math.round(finalNote);
            const nbE = 5 - nbF;
            const fullStar = "<span class='ti-star f'></span>";
            const emptyStar = "<span class='ti-star e'></span>";
            const finalStars = `${fullStar.repeat(nbF)}${emptyStar.repeat(nbE)}`;
            const tmp = document.createElement("div");
            tmp.classList.add("ti-stars");
            tmp.innerHTML = finalStars;
            globalNote.after(tmp);
        }
        globalNote.innerHTML = globalNote.innerHTML.replace(".", ",");
    }
};

const setupReviews = function () {
    const reviews = document.querySelectorAll(".ti-review-text-container");
    reviews.forEach((review) => {
        const height = calculateReviewHeight(review);
        setupReviewReadMore(review, height);
    });
};

const calculateReviewHeight = function (review) {
    const clone = review.cloneNode(true);
    clone.classList.add("read-more-calc");
    review.after(clone);

    const cloneHeight = clone.offsetHeight;
    clone.remove();

    review.style.setProperty("--maxh", cloneHeight + "px");
    return cloneHeight;
};

const setupReviewReadMore = function (review, height) {
    let readmore = review.nextSibling;
    while (readmore && readmore.nodeType != 1) {
        // We avoid whitespaces and comment nodes
        readmore = readmore.nextSibling;
    }
    const readmoreText = readmore.getAttribute("data-open-text");
    if (height > 110) {
        //readmore desktop
        review.classList.add("readmored-md");
    }
    if (height > 124) {
        //readmore mobile
        review.classList.add("readmored-sm");
    }
    readmore.innerHTML = readmoreText;

    const parent = review.closest(".ti-inner");
    parent.addEventListener("click", (event) => {
        const elTarget = event.target.closest(".ti-read-more");
        if (!elTarget) return;

        if (elTarget.classList.contains("close")) {
            // Closing
            const openText = elTarget.getAttribute("data-open-text");
            elTarget.classList.remove("close");
            elTarget.innerHTML = openText;

            let reviewText = elTarget.previousSibling;
            while (reviewText && reviewText.nodeType != 1) {
                // We avoid whitespaces and comment nodes
                reviewText = reviewText.previousSibling;
            }
            reviewText.classList.remove("opened");
        } else {
            // Opening
            const closeText = elTarget.getAttribute("data-collapse-text");
            elTarget.classList.add("close");
            elTarget.innerHTML = closeText;

            let reviewText = elTarget.previousSibling;
            while (reviewText && reviewText.nodeType != 1) {
                // We avoid whitespaces and comment nodes
                reviewText = reviewText.previousSibling;
            }
            reviewText.classList.add("opened");
        }
    });
};

const closeAllSubMenusBut = function (submenu) {
    const openMenus = document.querySelectorAll(
        "nav.elementor-nav-menu--dropdown:not(.elementor-nav-menu--main) .has-submenu.highlighted"
    );
    openMenus.forEach((submenu) => {
        if (!submenu.isEqualNode(submenu)) {
            submenu.click();
        }
    });
};

const headerSelector = ".elementor-location-header[data-elementor-type='header']";
const checkHeader = function (e) {
    const header = document.querySelector(headerSelector);
    if (window.scrollY > 0) {
        header.classList.add("header-scrolled");
    } else {
        header.classList.remove("header-scrolled");
    }
};
window.addEventListener("scroll", checkHeader);

function swapChildren(obj1, obj2) {
    var temp = obj2.innerHTML;
    obj2.innerHTML = obj1.innerHTML;
    obj1.innerHTML = temp;
}

function toggleMobileStyles() {
    updateIsMobile();

    if (is_mobile) {
        document.querySelectorAll("*[id^='_desktop_']").forEach(function (el) {
            const element = document.querySelector("#" + el.id);
            if (element.innerHTML) {
                var target = document.querySelector("#" + el.id.replace("_desktop_", "_mobile_"));
                if (target) {
                    swapChildren(element, target);
                }
            }
        });
    } else {
        document.querySelectorAll("*[id^='_mobile_']").forEach(function (el) {
            const element = document.querySelector("#" + el.id);
            if (element.innerHTML) {
                var target = document.querySelector("#" + el.id.replace("_mobile_", "_desktop_"));
                if (target) {
                    swapChildren(element, target);
                }
            }
        });
    }
}
function updateIsMobile() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    is_mobile = vw > 1024 ? false : true;
}
window.addEventListener("resize", function () {
    toggleMobileStyles();
});
